import { Dialog } from 'web-components-ts';
import { useTranslation } from 'react-i18next';
import { Button, Stack } from '@mui/material';

interface CancelAddEditBatchDialogProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  handleCancel: () => void;
}

// TODO: it can be used as a default cancel dialog. bc we never have a design for it any way
// would be good to have a default cancel dialog for all the components
export default function CancelAddEditBatchDialog({ open, setOpen, handleCancel }: CancelAddEditBatchDialogProps) {
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const onClickCloseCancelBatchDialog = () => {
    handleCloseDialog();
  };

  const onClickNotCancelBatch = () => {
    handleCloseDialog();
  };

  const onClickCancelBatch = () => {
    setTimeout(() => handleCloseDialog(), 0);
    handleCancel();
  };

  const dialogActionBar = (
    <Stack direction="row" spacing={2}>
      <Button variant="outlined" onClick={onClickNotCancelBatch}>
        {t('default_actions.cancel')}
      </Button>
      <Button variant="contained" color="error" onClick={onClickCancelBatch}>
        {t('default_actions.discard')}
      </Button>
    </Stack>
  );

  return open ? (
    <Dialog
      open={open}
      handleClose={onClickCloseCancelBatchDialog}
      title={t('default_actions.cancel_dialog.title')}
      subTitle={t('default_actions.cancel_dialog.subtitle')}
      maxHeight="98vh"
      maxWidth="800px"
      canSave
      actionBar={dialogActionBar}
      justifyContentActionBar="flex-end"
    />
  ) : null;
}
